export var REQUEST_SIGN_IN = 'REQUEST_SIGN_IN';
export var SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
export var FAILURE_SIGN_IN = 'FAILURE_SIGN_IN';
export var CLEAR_STATE = 'CLEAR_STATE_SIGN_IN';